import {
  CopyOutlined,
  DeleteOutlined,
  FileExcelOutlined,
  PlusOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Dropdown,
  Input,
  Menu,
  Pagination,
  Popconfirm,
  Row,
  Space,
  Table,
  Tabs,
  Tooltip,
  message,
} from 'antd';
import TabPane from 'antd/es/tabs/TabPane';
import dayjs from 'dayjs';
import 'jspdf-autotable';
import { useEffect, useMemo, useRef, useState, useCallback } from 'react';
import { CSVLink } from 'react-csv';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { ReactComponent as ColumnList } from '../../Images/ColumnList.svg';
import { ReactComponent as FilterIcon } from '../../Images/FilterIcon.svg';
import { ReactComponent as PlanPrintIcon } from '../../Images/SimplePrintIcon.svg';

import {
  deleteExcessStock,
  fetchExcessBundlesSummary,
  fetchExcessStockBundlesSummary,
  resetexcessStockData,
  resetexcessStockListBundle,
} from '../../slices/excess-stock';
import { fetchWorkOrderStatusData } from '../../slices/work-order';
import ShiftBundleToWorkOrder from './ShiftBundleToWorkOrder';
import { debounce } from 'lodash';
import { fetchAndSetIpAddress } from '../../slices/ipSlice';
import { createActivityLog } from '../../slices/activity-log';
import eventBus from '../../utils/eventBus';

function ExcessStockList() {
  const csvLinkRef = useRef();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const { data, totalBundleSummary, status, totalRecord } = useSelector(
    state => state.excessStock,
  );

  const {
    listBundles = [],
    totalRecordBundles,
    statusBundles,
  } = useSelector(state => state.excessStock);

  const ipAddress = useSelector(state => state.ip.ipAddress);
  useEffect(() => {
    if (!ipAddress) {
      dispatch(fetchAndSetIpAddress());
    }
  }, [ipAddress, dispatch]);

  const { user: currentUser } = useSelector(state => state.auth);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [activeTab, setActiveTab] = useState('1');
  const [csvData, setCsvData] = useState([]);

  const [orderBy, setOrderBy] = useState('');
  const [orderByBundle, setOrderByBundle] = useState('');
  const [page, setPage] = useState(1);
  const [pageBundle, setPageBundle] = useState(1);
  const [pagesize, setPageSize] = useState(20);
  const [pagesizeBundle, setPageSizeBundle] = useState(20);
  const [search, setSearch] = useState(
    localStorage.getItem('die_text_search_BundlesSummary') || '',
  );
  const [searchBundle, setSearchBundle] = useState(
    localStorage.getItem('die_text_search_Bundles') || '',
  );
  const [inputValue, setInputValue] = useState(
    localStorage.getItem('die_text_search_BundlesSummary') || '',
  );
  const [inputBundle, setInputBundle] = useState(
    localStorage.getItem('die_text_search_Bundles') || '',
  );
  const [groupSearch, setGroupSearch] = useState(() => {
    const saved = localStorage.getItem('die_group_search_BundlesSummary');
    return saved ? JSON.parse(saved) : null;
  });
  const [groupBundlesSearch, setGroupBundlesSearch] = useState(() => {
    const saved = localStorage.getItem('die_group_search_Bundles');
    return saved ? JSON.parse(saved) : null;
  });
  const [checkedList, setCheckedList] = useState([
    'SrNo',
    'profile',
    'img',
    'profile_image',
    'profile_description',
    'alloy',
    'color_code',
    'length',
    'temper',
    'total_weight',
    'total_pieces',
    'total_bundles',
    'action',
  ]);

  const [checkedListBundles, setCheckedListBundles] = useState([
    'SrNo',
    'bundle_no',
    'img',
    'profile_image',
    'profile_description',
    'profile',
    'length',
    'weight',
    'pieces',
    'packing_date',
    'status',
    'action',
  ]);

  const handleColumnVisibilityChange = checkedValues => {
    setCheckedList(checkedValues);
  };

  const handleColumnVisibilityChangeBundles = checkedValues => {
    setCheckedListBundles(checkedValues);
  };

  const handleCopyBasedOnTab = () => {
    if (activeTab === '1') {
      handleCopyColumnData();
    } else if (activeTab === '2') {
      handleCopyStockBundle();
    }
  };

  const columnMap = {
    SrNo: 'Sr. No.',
    profile: 'Profile',
    profile_description: 'Profile Description',
    length: 'Length',
    alloy: 'Alloy',
    color_code: 'Color Code',
    temper: 'Temper',
    total_weight: 'Total Weight (kg)',
    total_pieces: 'Total Pieces',
    total_bundles: 'Total Bundles',
  };

  const handlePageSizeChange = (current, size) => {
    setPage(1); // Reset to first page if needed
    setPageSize(size); // You must have a setter or state update
  };

  const handlePageSizeChangeBundle = (current, size) => {
    setPageBundle(1); // Reset to first page if needed
    setPageSizeBundle(size); // You must have a setter or state update
  };

  const handleCopyColumnData = async () => {
    const count = totalRecord;

    try {
      const response = await dispatch(
        fetchExcessStockBundlesSummary({
          page: 1,
          pagesize: count,
          ...(search && { search }),
          ...(orderBy && { ordering: orderBy }),
        }),
      ).unwrap();

      const stockData = response?.results?.data || [];

      if (stockData.length === 0) {
        console.warn('No stock data found.');
        return;
      }

      const headers = checkedList
        .filter(key => columnMap[key] && key !== 'img' && key !== 'action') // Exclude 'img' and 'action'
        .map(key => columnMap[key])
        .join('\t');

      const rows = stockData.map((item, index) => {
        return checkedList
          .filter(key => columnMap[key] && key !== 'img' && key !== 'action')
          .map(key => {
            switch (key) {
              case 'SrNo':
                return index + 1;

              case 'total_weight':
                return item.total_weight !== null &&
                  item.total_weight !== undefined
                  ? `\u200B${Number(item.total_weight).toLocaleString('en-IN', {
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                  })}`
                  : 'N/A';

              case 'total_pieces':
              case 'total_bundles':
                return item[key] !== null && item[key] !== undefined
                  ? `\u200B${item[key]}`
                  : 'N/A';

              case 'profile':
                return item.profile ? `="${item.profile}"` : 'N/A';

              default:
                return item[key] ?? 'N/A';
            }
          })
          .join('\t');
      });

      const textToCopy = [headers, ...rows].join('\n\n');

      try {
        await navigator.clipboard.writeText(textToCopy);
        message.success('Table data copied to clipboard');
      } catch (clipboardError) {
        const textarea = document.createElement('textarea');
        textarea.value = textToCopy;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
      }
    } catch (error) {
      console.error('Failed to fetch or copy column data:', error);
    }
  };

  const handleCopyStockBundle = async () => {
    const count = totalRecordBundles;

    try {
      const response = await dispatch(
        fetchExcessBundlesSummary({
          pagesize: count,
          page: 1,
          ...(searchBundle && { search: searchBundle }),
          ...(orderByBundle && { ordering: orderByBundle }),
        }),
      ).unwrap();

      const stockData = response?.results?.data || [];

      if (stockData.length === 0) {
        console.warn('No stock data found.');
        return;
      }

      const headersMap = {
        SrNo: 'Sr. No.',
        bundle_no: 'Bundle No.',
        profile: 'Profile',
        profile_description: 'Profile Description',
        length: 'Length',
        weight: 'Weight (kg)',
        pieces: 'Pieces',
        packing_date: 'Packing Date',
        status: 'Status',
      };
      const filteredKeys = checkedListBundles.filter(
        key =>
          headersMap[key] && !['img', 'action', 'profile_image'].includes(key),
      );

      const headers = filteredKeys.map(key => headersMap[key]).join('\t');

      const rows = stockData.map((item, index) => {
        return filteredKeys
          .map(key => {
            switch (key) {
              case 'SrNo':
                return index + 1;
              case 'packing_date':
                return item.packing_date
                  ? dayjs(item.packing_date).format('DD-MM-YYYY hh:mm')
                  : 'N/A';
              case 'profile':
              case 'bundle_no':
                return item[key] !== undefined && item[key] !== null
                  ? `="${item[key]}"`
                  : 'N/A';
              default:
                return item[key] !== undefined && item[key] !== null
                  ? item[key]
                  : 'N/A';
            }
          })
          .join('\t');
      });

      const textToCopy = [headers, ...rows].join('\n');

      try {
        await navigator.clipboard.writeText(textToCopy);
        message.success('Table data copied to clipboard');
      } catch (clipboardError) {
        console.error('Clipboard access denied:', clipboardError);
        const textarea = document.createElement('textarea');
        textarea.value = textToCopy;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
      }
    } catch (error) {
      console.error('Failed to fetch or copy column data:', error);
    }
  };

  const allCsvColumns = [
    { header: 'Sr. No.', dataKey: 'SrNo', field: 'SrNo' },
    { header: 'Profile', dataKey: 'profile', field: 'profile' },
    {
      header: 'profile Description',
      dataKey: 'profile_description',
      field: 'profile_description',
    },
    { header: 'Length', dataKey: 'length', field: 'length' },
    { header: 'Alloy', dataKey: 'alloy', field: 'alloy' },
    { header: 'Color Code', dataKey: 'color_code', field: 'color_code' },
    { header: 'Temper', dataKey: 'temper', field: 'temper' },
    {
      header: 'Total Weight(kg)',
      dataKey: 'total_weight',
      field: 'total_weight',
    },
    { header: 'Total Pieces', dataKey: 'total_pieces', field: 'total_pieces' },
    { header: 'Total Bundle', dataKey: 'total_bundles', field: 'total_bundles' },
    { header: 'Created At', dataKey: 'createdAt', field: 'created_at' },
    { header: 'Created By', dataKey: 'createdBy', field: 'created_by' },
    { header: 'Updated At', dataKey: 'updatedAt', field: 'updated_at' },
    { header: 'Updated By', dataKey: 'updatedBy', field: 'updated_by' },
  ];
  const handleTabChange = key => {
    setActiveTab(key);
  };

  const handleExcel = async () => {
    const count = totalRecord;

    if (count > 0) {
      const response = await dispatch(
        fetchExcessStockBundlesSummary({
          page: 1,
          pagesize: count,
          ...(search && { search }),
          ...(orderBy && { ordering: orderBy }),
        }),
      ).unwrap();

      const stockData = response?.results?.data || [];
      const csvListData = stockData.map((item, index) => {
        const row = {
          SrNo: index + 1, // Add serial number as the first column
        };
        allCsvColumns
          .filter(col => checkedList.includes(col.field))
          .forEach(col => {
            if (col.field === 'SrNo') return; // Skip sr_no as it's already added

            switch (col.field) {
              case 'profile':
                row.profile = item?.profile || 'N/A';
                break;
              case 'profile_description':
                row.profile_description = item?.profile_description || 'N/A';
                break;
              case 'length':
                row.length =
                  item?.length !== null && item?.length !== undefined
                    ? item.length
                    : 'N/A';
                break;
              case 'alloy':
                row.alloy = item?.alloy || 'N/A';
                break;
              case 'color_code':
                row.color_code = item?.color_code || 'N/A';
                break;
              case 'temper':
                row.temper = item?.temper || 'N/A';
                break;
              case 'total_weight':
                row.total_weight =
                  item?.total_weight !== null &&
                    item?.total_weight !== undefined
                    ? item.total_weight
                    : 'N/A';
                break;
              case 'total_pieces':
                row.total_pieces =
                  item?.total_pieces !== null &&
                    item?.total_pieces !== undefined
                    ? item.total_pieces
                    : 'N/A';
                break;
              case 'total_bundles':
                row.total_bundles =
                  item?.total_bundles !== null &&
                    item?.total_bundles !== undefined
                    ? item.total_bundles
                    : 'N/A';
                break;

                row.updatedBy = item?.updated_by || 'N/A';
                break;
              default:
                row[col.dataKey] = 'N/A';
            }
          });
        return row;
      });

      setCsvData(csvListData);
      setTimeout(() => {
        csvLinkRef.current?.link.click();
      }, 500);
    }
  };

  const activityLog = async () => {
    dispatch(
      createActivityLog({
        action: 'DOWNLOAD',
        module_name: 'Excess Stock',
        ip_address: ipAddress,
        discription: 'Excess stock excel download successfully!',
      }),
    );
  };
  const csvHeaders = allCsvColumns
    .filter(col => checkedList.includes(col.field)) // Filter only selected columns
    .map(col => ({
      label: col.header, // CSV column header
      key: col.dataKey, // Corresponding data key
    }));

  const allCsvColumnsBundle = [
    { header: 'Sr. No.', dataKey: 'SrNo', field: 'SrNo' },
    { header: 'Bundle No', dataKey: 'bundle_no', field: 'bundle_no' },
    { header: 'Profile', dataKey: 'profile', field: 'profile' },
    {
      header: 'Profile Description',
      dataKey: 'profile_description',
      field: 'profile_description',
    },
    { header: 'Length', dataKey: 'length', field: 'length' },
    {
      header: 'Weight(kg)',
      dataKey: 'weight',
      field: 'weight',
    },
    { header: 'Pieces', dataKey: 'pieces', field: 'pieces' },
    { header: 'Packing Date', dataKey: 'packing_date', field: 'packing_date' },
    { header: 'Status', dataKey: 'status', field: 'status' },
  ];

  const handleExcelBundle = async () => {
    const count = totalRecordBundles;

    if (count > 0) {
      try {
        const response = await dispatch(
          fetchExcessBundlesSummary({
            pagesize: count,
            page: 1,
            ...(searchBundle && { search: searchBundle }),
            ...(orderByBundle && { ordering: orderByBundle }),
          }),
        ).unwrap();

        const bundleData = response?.results?.data || [];
        const csvListData = bundleData.map((item, index) => {
          const row = {
            SrNo: index + 1, // Add serial number as the first column
          };
          allCsvColumnsBundle
            .filter(col => checkedListBundles.includes(col.field))
            .forEach(col => {
              if (col.field === 'SrNo') return; // Skip sr_no as it's already added

              switch (col.field) {
                case 'bundle_no':
                  row.bundle_no = item?.bundle_no || 'N/A';
                  break;
                case 'profile':
                  row.profile = item?.profile || 'N/A';
                  break;
                case 'profile_description':
                  row.profile_description = item?.profile_description || 'N/A';
                  break;
                case 'length':
                  row.length =
                    item?.length !== null && item?.length !== undefined
                      ? item.length
                      : 'N/A';
                  break;
                case 'weight':
                  row.weight =
                    item?.weight !== null && item?.weight !== undefined
                      ? item.weight
                      : 'N/A';
                  break;
                case 'pieces':
                  row.pieces =
                    item?.pieces !== null && item?.pieces !== undefined
                      ? item.pieces
                      : 'N/A';
                  break;
                case 'packing_date':
                  row.packing_date =
                    dayjs(item?.packing_date).format('DD-MM-YYYY hh:mm') ||
                    'N/A';
                  break;
                case 'status':
                  row.status = item?.status || 'N/A';
                  break;
                default:
                  row[col.dataKey] = 'N/A';
              }
            });
          return row;
        });

        setCsvData(csvListData);
        setTimeout(() => {
          csvLinkRef.current?.link.click();
        }, 500);
      } catch (error) {
        console.error('Failed to fetch bundle data for Excel export:', error);
      }
    }
  };
  const csvBundleHeaders = allCsvColumnsBundle
    .filter(col => checkedListBundles.includes(col.field)) // Filter only selected columns
    .map(col => ({
      label: col.header, // CSV column header
      key: col.dataKey, // Corresponding data key
    }));

  const handleExportBasedOnTab = () => {
    if (activeTab === '1') {
      handleExcel();
    } else if (activeTab === '2') {
      handleExcelBundle();
    }
  };

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'SrNo', // Use a unique key for the serial number
      key: 'SrNo',
      width: '8%',
    },
    {
      title: 'Profile',
      dataIndex: 'profile',
      key: 'profile',
      sorter: true,
    },
    {
      title: 'Profile Image',
      dataIndex: 'profile_image',
      key: 'profile_image',

      render: profile_image => {
        if (!profile_image) return <span>N/A</span>;

        const isPDF = profile_image.toLowerCase().endsWith('.pdf');

        return isPDF ? (
          <a href={profile_image} target="_blank" rel="noopener noreferrer">
            View PDF
          </a>
        ) : (
          <img
            src={profile_image}
            alt="Profile"
            style={{
              width: '90px',
              height: '50px',
              objectFit: 'contain',
              maxHeight: '100%',
            }}
          />
        );
      },
    },
    {
      title: 'Profile Description',
      dataIndex: 'profile_description',
      key: 'profile_description',
      sorter: true,
    },
    {
      title: 'Length',
      dataIndex: 'length',
      key: 'length',
      sorter: true,
    },
    {
      title: 'Alloy',
      dataIndex: 'alloy',
      key: 'alloy',
    },
    {
      title: 'Color Code',
      dataIndex: 'color_code',
      key: 'color_code',
      sorter: true,
    },
    {
      title: 'Temper',
      dataIndex: 'temper',
      key: 'temper',
      sorter: true,
    },
    {
      title: 'Total Weight (kg)',
      dataIndex: 'total_weight',
      key: 'total_weight',
      sorter: true,
    },
    {
      title: 'Total Pieces',
      dataIndex: 'total_pieces',
      key: 'total_pieces',
      sorter: true,
    },
    {
      title: 'Total Bundles',
      dataIndex: 'total_bundles',
      key: 'total_bundles',
      sorter: true,
    },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      key: 'created_at',
      render: record => {
        return (
          <span>
            {record ? dayjs(record).format('DD-MM-YYYY HH:mm') : 'N/A'}{' '}
          </span>
        );
      },
    },
    {
      title: 'Created By',
      dataIndex: 'created_by',
      key: 'created_by',
      render: record => {
        return (
          <span>
            {record ? `${record.first_name} ${record.last_name}` : 'N/A'}{' '}
          </span>
        );
      },
    },
    {
      title: 'Updated At',
      dataIndex: 'updated_at',
      key: 'updated_at',
      render: record => {
        return (
          <span>
            {record && record.trim()
              ? dayjs(record).format('DD-MM-YYYY HH:mm')
              : 'N/A'}
          </span>
        );
      },
    },
    {
      title: 'Updated By',
      dataIndex: 'updated_by',
      key: 'updated_by',
      render: record => {
        return (
          <span>
            {record && record.first_name?.trim() && record.last_name?.trim()
              ? `${record.first_name} ${record.last_name}`
              : 'N/A'}
          </span>
        );
      },
    },
  ];

  const columnsBundles = [
    {
      title: 'Sr. No.',
      dataIndex: 'SrNo', // Use a unique key for the serial number
      key: 'SrNo',
      width: '8%',
    },
    {
      title: 'Bundle No.',
      dataIndex: 'bundle_no',
      key: 'bundle_no',
      sorter: true,
      render: record => {
        return record;
      },
    },
    {
      title: 'Profile',
      dataIndex: 'profile',
      key: 'profile',
    },
    {
      title: 'Profile Image',
      dataIndex: 'profile_image',
      key: 'profile_image',
      align: 'center',
      render: profile_image => {
        return profile_image ? (
          <img
            src={profile_image}
            alt="Profile image"
            style={{
              width: '90px',
              height: '50px',
              objectFit: 'contain',
              maxHeight: '100%',
            }}
          />
        ) : (
          <span style={{ textAlign: 'center' }}>N/A</span>
        );
      },
    },
    {
      title: 'Profile Description',
      dataIndex: 'profile_description',
      key: 'profile_description',
      sorter: true,
    },
    {
      title: 'Length',
      dataIndex: 'length',
      key: 'length',
      sorter: true,
    },
    {
      title: 'Weight (kg)',
      dataIndex: 'weight',
      key: 'weight',
      sorter: true,
    },
    {
      title: 'Pieces',
      dataIndex: 'pieces',
      key: 'pieces',
      sorter: true,
    },
    {
      title: 'Packing Date',
      dataIndex: 'packing_date',
      key: 'packing_date',
      render: record => {
        return (
          <span>{record ? dayjs(record).format('DD-MM-YYYY') : 'N/A'} </span>
        );
      },
      sorter: true,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',

      sorter: true,
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          {currentUser.permissions.permissions.bundle_inward.includes(
            'view_excessstock',
          ) && (
              <Tooltip title="Print">
                <PlanPrintIcon
                  style={{ cursor: 'pointer' }}
                  onClick={() => handlePrintBundle(record.id)}
                />
              </Tooltip>
            )}
          {currentUser.permissions.permissions.bundle_inward.includes(
            'delete_excessstock',
          ) && (
              <Link>
                <Tooltip title="Delete">
                  <Popconfirm
                    title="Are you sure you want to delete this record?"
                    onConfirm={() => handleDeleteBundle(record?.id)} // Correctly access `id`
                    onCancel={() => message.info('Action cancelled')}
                    okText="Yes"
                    cancelText="No"
                  >
                    <DeleteOutlined
                      style={{ cursor: 'pointer', fontSize: '18px' }}
                    />
                  </Popconfirm>
                </Tooltip>
              </Link>
            )}
        </Space>
      ),
    },
  ];

  const handlePrintBundle = id => {
    window.open(`/print-excess-stock/${id}`, '_blank');
  };

  const handleDeleteBundle = id => {
    if (!id) {
      message.error('Missing ID for deletion!');
      return;
    }
    dispatch(deleteExcessStock(id))
      .unwrap()
      .then(() => {
        message.success('Excess stock bundle deleted permanently!');
        dispatch(resetexcessStockListBundle());

        dispatch(
          fetchExcessBundlesSummary({
            pagesize: pagesize,
            page: pageBundle,
            ...(searchBundle && { search: searchBundle }),
            ...(orderByBundle && { ordering: orderByBundle }),
          }),
        );
      })
      .catch(error => {
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }

          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error); // Handle string error
        } else if (error instanceof Error) {
          message.error(error.message); // Handle Error object
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };

  const filteredColumns = columns.filter(column =>
    checkedList.includes(column.key),
  );

  const filteredColumnsBundles = columnsBundles.filter(column =>
    checkedListBundles.includes(column.key),
  );

  const fetchActiveTabData = useCallback(() => {
    if (activeTab === "1") {
      dispatch(resetexcessStockData());
      dispatch(
        fetchExcessStockBundlesSummary({
          page: page,
          pagesize: pagesize,
          ...(search && { search }),
          ...(orderBy && { ordering: orderBy }),
        }),
      );
    }

    if (activeTab === "2") {
      dispatch(resetexcessStockListBundle());
      dispatch(
        fetchExcessBundlesSummary({
          page: pageBundle,
          pagesize: pagesizeBundle,
          ...(searchBundle && { search: searchBundle }),
          ...(orderByBundle && { ordering: orderByBundle }),
        }),
      );
    }

    if (activeTab === "3") {
      dispatch(
        fetchWorkOrderStatusData({
          page: 1,
          pagesize: 1000,
        }),
      );
    }
  }, [activeTab, activeTab, pageBundle, pagesizeBundle, searchBundle, orderByBundle, page, pagesize, orderBy, dispatch]);

  useEffect(() => {
    fetchActiveTabData();
  }, [fetchActiveTabData]);

  useEffect(() => {
    const handleReload = () => {
      fetchActiveTabData();
    };

    eventBus.on("financialYear:refresh", handleReload);
    return () => eventBus.off("financialYear:refresh", handleReload);
  }, [fetchActiveTabData]);

  const dataSource = data.map((item, index) => ({
    ...item,
    key: item.id || index,
    SrNo: (page - 1) * pagesize + index + 1, // Calculate Sr. No. based on page and limit
  }));

  const dataSourceBundles = listBundles.map((item, index) => ({
    ...item,
    key: item.id || index,
    SrNo: (pageBundle - 1) * pagesizeBundle + index + 1, // Calculate Sr. No. based on page and limit
  }));

  const handleTableChange = async (pagination, filters, sorter) => {
    if (sorter?.columnKey && sorter.order) {
      const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
      setOrderBy(orderBy);
    }
  };
  const handleTableChangeBundle = async (pagination, filters, sorter) => {
    if (sorter?.columnKey && sorter.order) {
      const orderBy = GetSortingEnumValueBundle(sorter.columnKey, sorter.order);
      setOrderByBundle(orderBy);
    }
  };
  const debounceTimeout = useRef(null);

  const handleSearch = e => {
    const value = e.target.value;
    debouncedAPICall(value);
    setInputValue(value);
    setSearch(value);
    localStorage.setItem('die_text_search_BundlesSummary', value);
  };
  const debouncedAPICall = useMemo(
    () =>
      debounce(query => {
        if (query.length >= 3) {
          dispatch(fetchExcessStockBundlesSummary({ search: query }));
          localStorage.setItem('die_text_search_BundlesSummary', query);
        }
      }, 100),
    [],
  );

  useEffect(() => {
    return () => {
      debouncedAPICall.cancel();
    };
  }, [debouncedAPICall]);

  const handleSearchBundle = e => {
    const value = e.target.value;
    debouncedAPICall(value);
    setInputBundle(value);
    setSearchBundle(value);
    localStorage.setItem('die_text_search_Bundles', value);
  };
  const debouncedAPICallBundle = useMemo(
    () =>
      debounce(query => {
        if (query.length >= 3) {
          dispatch(fetchExcessBundlesSummary({ search: query }));
          localStorage.setItem('die_text_search_Bundles', query);
        }
      }, 100),
    [],
  );

  useEffect(() => {
    return () => {
      debouncedAPICallBundle.cancel();
    };
  }, [debouncedAPICallBundle]);

  useEffect(() => {
    return () => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
    };
  }, []);

  const handlePageChange = newPage => {
    setPage(newPage);
    setOrderBy('');
  };

  const handlePageChangeBundle = newPage => {
    setPageBundle(newPage);
    setOrderByBundle('');
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = 'id';
    if (sortField === 'profile' && sortOrder === 'ascend') {
      sortingEnumKey = 'profile';
    }
    if (sortField === 'profile' && sortOrder === 'descend') {
      sortingEnumKey = '-profile';
    }
    if (sortField === 'profile_image' && sortOrder === 'ascend') {
      sortingEnumKey = 'profile_image';
    }
    if (sortField === 'profile_image' && sortOrder === 'descend') {
      sortingEnumKey = '-profile_image';
    }
    if (sortField === 'profile_description' && sortOrder === 'ascend') {
      sortingEnumKey = 'profile_description';
    }
    if (sortField === 'profile_description' && sortOrder === 'descend') {
      sortingEnumKey = '-profile_description';
    }
    if (sortField === 'length' && sortOrder === 'ascend') {
      sortingEnumKey = 'length';
    }
    if (sortField === 'length' && sortOrder === 'descend') {
      sortingEnumKey = '-length';
    }
    if (sortField === 'alloy' && sortOrder === 'ascend') {
      sortingEnumKey = 'alloy';
    }
    if (sortField === 'alloy' && sortOrder === 'descend') {
      sortingEnumKey = '-alloy';
    }
    if (sortField === 'color_code' && sortOrder === 'ascend') {
      sortingEnumKey = 'color_code';
    }
    if (sortField === 'color_code' && sortOrder === 'descend') {
      sortingEnumKey = '-color_code';
    }
    if (sortField === 'temper' && sortOrder === 'ascend') {
      sortingEnumKey = 'temper';
    }
    if (sortField === 'temper' && sortOrder === 'descend') {
      sortingEnumKey = '-temper';
    }
    if (sortField === 'total_weight' && sortOrder === 'ascend') {
      sortingEnumKey = 'total_weight';
    }
    if (sortField === 'total_weight' && sortOrder === 'descend') {
      sortingEnumKey = '-total_weight';
    }
    if (sortField === 'total_pieces' && sortOrder === 'ascend') {
      sortingEnumKey = 'total_pieces';
    }
    if (sortField === 'total_pieces' && sortOrder === 'descend') {
      sortingEnumKey = '-total_pieces';
    }
    if (sortField === 'total_bundles' && sortOrder === 'ascend') {
      sortingEnumKey = 'total_bundles';
    }
    if (sortField === 'total_bundles' && sortOrder === 'descend') {
      sortingEnumKey = '-total_bundles';
    }
    if (sortField === 'created_at' && sortOrder === 'ascend') {
      sortingEnumKey = 'created_at';
    }
    if (sortField === 'created_at' && sortOrder === 'descend') {
      sortingEnumKey = '-created_at';
    }
    if (sortField === 'created_by' && sortOrder === 'ascend') {
      sortingEnumKey = 'created_by';
    }
    if (sortField === 'created_by' && sortOrder === 'descend') {
      sortingEnumKey = '-created_by';
    }
    if (sortField === 'updated_at' && sortOrder === 'ascend') {
      sortingEnumKey = 'updated_at';
    }
    if (sortField === 'updated_at' && sortOrder === 'descend') {
      sortingEnumKey = '-updated_at';
    }
    if (sortField === 'updated_by' && sortOrder === 'ascend') {
      sortingEnumKey = 'updated_by';
    }
    if (sortField === 'updated_by' && sortOrder === 'descend') {
      sortingEnumKey = '-updated_by';
    }
    return sortingEnumKey;
  };
  const GetSortingEnumValueBundle = (sortField, sortOrder) => {
    let sortingEnumKey = 'id';
    if (sortField === 'bundle_no' && sortOrder === 'ascend') {
      sortingEnumKey = 'bundle_no';
    }
    if (sortField === 'bundle_no' && sortOrder === 'descend') {
      sortingEnumKey = '-bundle_no';
    }
    if (sortField === 'profile_image' && sortOrder === 'ascend') {
      sortingEnumKey = 'profile_image';
    }
    if (sortField === 'profile_image' && sortOrder === 'descend') {
      sortingEnumKey = '-profile_image';
    }
    if (sortField === 'profile_description' && sortOrder === 'ascend') {
      sortingEnumKey = 'profile_description';
    }
    if (sortField === 'profile_description' && sortOrder === 'descend') {
      sortingEnumKey = '-profile_description';
    }
    if (sortField === 'length' && sortOrder === 'ascend') {
      sortingEnumKey = 'length';
    }
    if (sortField === 'length' && sortOrder === 'descend') {
      sortingEnumKey = '-length';
    }
    if (sortField === 'weight' && sortOrder === 'ascend') {
      sortingEnumKey = 'weight';
    }
    if (sortField === 'weight' && sortOrder === 'descend') {
      sortingEnumKey = '-weight';
    }
    if (sortField === 'pieces' && sortOrder === 'ascend') {
      sortingEnumKey = 'pieces';
    }
    if (sortField === 'pieces' && sortOrder === 'descend') {
      sortingEnumKey = '-pieces';
    }
    if (sortField === 'avg_weight' && sortOrder === 'ascend') {
      sortingEnumKey = 'avg_weight';
    }
    if (sortField === 'avg_weight' && sortOrder === 'descend') {
      sortingEnumKey = '-avg_weight';
    }
    if (sortField === 'packing_date' && sortOrder === 'ascend') {
      sortingEnumKey = 'packing_date';
    }
    if (sortField === 'packing_date' && sortOrder === 'descend') {
      sortingEnumKey = '-packing_date';
    }
    if (sortField === 'status' && sortOrder === 'ascend') {
      sortingEnumKey = 'status';
    }
    if (sortField === 'status' && sortOrder === 'descend') {
      sortingEnumKey = '-status';
    }
    return sortingEnumKey;
  };

  const resetFilter = () => {
    setSearch('');
    setGroupSearch('');
    setInputValue('');
    setOrderBy(null); // if applicable
    localStorage.removeItem('die_text_search_BundlesSummary');
    localStorage.removeItem('die_group_search_BundlesSummary');
    dispatch(fetchExcessStockBundlesSummary({ page: 1, pagesize }));
  };

  const resetFilterBundle = () => {
    setSearchBundle('');
    setGroupBundlesSearch('');
    setInputBundle('');
    setOrderBy(null); // if applicable
    localStorage.removeItem('die_text_search_Bundles');
    localStorage.removeItem('die_group_search_Bundles');
    dispatch(fetchExcessBundlesSummary({ page: 1, pagesize }));
  };

  const columnMenu = (
    <Menu className="packagelistdropdown">
      <Menu.Item key="columnMenu">
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
        >
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Checkbox value="SrNo" disabled>
                Sr. No.
              </Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="profile">Profile</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="profile_image">Profile Image</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="length">Length</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="alloy">Alloy</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="profile_description">
                Profile Description
              </Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="temper">Temper</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="total_weight">Total Weight</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="total_pieces">Total Pieces</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="total_bundles">Total Bundle</Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  const columnMenuBundle = (
    <Menu className="packagelistdropdown">
      <Menu.Item key="columnMenuBundles">
        <Checkbox.Group
          value={checkedListBundles}
          onChange={handleColumnVisibilityChangeBundles}
        >
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Checkbox value="SrNo" disabled>
                Sr. No.
              </Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="bundle_no">Bundle No.</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="profile">Profile</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="profile_image">Profile Image</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="length">Length</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="profile_description">
                Profile Description
              </Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="weight">Weight</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="pieces">Pieces</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="packing_date">Packing Date</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="status">Status</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="action" disabled>
                Action
              </Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  return (
    <div>
      <div className="sticyaction">
        <div className="sticky-header">
          <Row
            className="pagenamerow mb-0 "
            justify="space-between"
            align="middle"
          >
            <Col>
              <h2 style={{ margin: 0 }}>Excess Stock</h2>
              <div className="bredcrumbwrp">
                <Link onClick={() => navigate(-1)} className="back">
                  <Back /> BACK
                </Link>
                <Breadcrumb
                  items={[
                    { title: <Link to="/dashboard">Home</Link> },
                    { title: 'Excess Stock' },
                  ]}
                />
              </div>
            </Col>
            {activeTab !== '3' && (
              <Col>
                <Space size="small">
                  <Input
                    placeholder="Search"
                    className="searchbox"
                    prefix={<SearchOutlined />}
                    value={activeTab === '1' ? search : searchBundle}
                    onChange={e => {
                      if (activeTab === '1') handleSearch(e);
                      else handleSearchBundle(e);
                    }}
                    style={{ width: '100%' }}
                  />
                  <Tooltip title="Filter">
                    <Button
                      type="primary"
                      disabled={
                        activeTab === '1'
                          ? !search && !orderBy
                          : !searchBundle && !orderByBundle
                      }
                      className="iconlink"
                      onClick={() => {
                        if (activeTab === '1') {
                          resetFilter();
                        } else {
                          resetFilterBundle();
                        }
                      }}
                    >
                      <FilterIcon />
                    </Button>
                  </Tooltip>

                  {currentUser.permissions.permissions.bundle_inward.includes(
                    'download_excess_stock_excel_copy',
                  ) && (
                      <>
                        {activeTab !== '3' &&
                          currentUser.permissions.permissions.bundle_inward.includes(
                            'download_excess_stock_excel_copy',
                          ) && (
                            <>
                              <Tooltip
                                title={
                                  activeTab === '1'
                                    ? 'Copy Excess Stock Bundles Summary'
                                    : 'Copy Excess Stock Bundles'
                                }
                              >
                                <Button
                                  type="primary"
                                  className="iconlink"
                                  onClick={handleCopyBasedOnTab}
                                >
                                  <CopyOutlined />
                                </Button>
                              </Tooltip>

                              <Tooltip
                                placement="top"
                                title={
                                  activeTab === '1'
                                    ? 'Export Excess Stock Bundles Summary Excel'
                                    : 'Export Excess Stock Bundles Excel'
                                }
                              >
                                <Button
                                  type="primary"
                                  className="iconlink"
                                  style={{ width: '10px' }}
                                  onClick={handleExportBasedOnTab}
                                >
                                  <FileExcelOutlined onClick={activityLog} />
                                </Button>
                              </Tooltip>
                            </>
                          )}
                        <CSVLink
                          data={csvData}
                          filename={
                            activeTab === '1'
                              ? 'Excess Stock Bundles Summary.csv'
                              : 'Excess Stock Bundles.csv'
                          }
                          headers={
                            activeTab === '1' ? csvHeaders : csvBundleHeaders
                          }
                          className="hidden"
                          ref={csvLinkRef}
                        >
                          Download
                        </CSVLink>
                      </>
                    )}
                  {currentUser.permissions.permissions.bundle_inward.includes(
                    'add_excessstock',
                  ) && (
                      <Tooltip title="Add New Bundle to Excess Stock">
                        <Link to="/create-excess-stock">
                          <Button type="primary" icon={<PlusOutlined />}>
                            Add New Bundle to Excess Stock
                          </Button>
                        </Link>
                      </Tooltip>
                    )}

                  <div className="gridiconswrap">
                    <Tooltip placement="topLeft" title="Column Filter Options">
                      <Dropdown
                        overlay={
                          activeTab === '1' ? columnMenu : columnMenuBundle
                        }
                        trigger={['click']}
                        placement="bottomRight"
                        visible={dropdownVisible}
                        onVisibleChange={setDropdownVisible}
                      >
                        <Button
                          type="primary"
                          icon={<ColumnList />}
                          onClick={e => e.preventDefault()}
                        />
                      </Dropdown>
                    </Tooltip>
                  </div>
                </Space>
              </Col>
            )}
          </Row>
        </div>
      </div>
      <div
        style={{ position: 'sticky', top: 0, zIndex: 1000, background: '#fff' }}
      >
        <Tabs
          defaultActiveKey="1"
          className="tabletab px-4 "
          activeKey={activeTab}
          onChange={handleTabChange}
        >
          <TabPane tab="Excess Stock Bundles Summary" key="1">
            <div
              style={{
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <div style={{ flex: 1 }}>
                <Table
                  rowKey="id"
                  columns={filteredColumns}
                  dataSource={dataSource}
                  pagination={false} // Disable built-in pagination
                  loading={status === 'loading'}
                  onChange={handleTableChange}
                  scroll={{ x: '600px' }}
                />
              </div>
              <div
                style={{
                  position: 'sticky',
                  bottom: 0,
                  zIndex: 1000,
                  background: '#fff',
                  padding: 10,
                  display: 'flex',
                  justifyContent: 'flex-end',
                }}
              >
                <Pagination
                  current={page}
                  pageSize={pagesize}
                  total={totalBundleSummary}
                  showSizeChanger
                  onShowSizeChange={handlePageSizeChange}
                  pageSizeOptions={["20", "50", "100"]}
                  showTotal={total => `Total ${total} items`}
                  onChange={handlePageChange}
                  locale={{ items_per_page: 'Items / Page' }}
                />
              </div>
            </div>
          </TabPane>
          <TabPane tab="Excess Stock Bundles" key="2">
            <div
              style={{
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <div style={{ flex: 1 }}>
                <Table
                  rowKey="id"
                  // rowSelection={rowSelection}
                  columns={filteredColumnsBundles}
                  dataSource={dataSourceBundles}
                  pagination={false} // Disable built-in pagination
                  loading={status === 'loading'}
                  onChange={handleTableChangeBundle}
                  scroll={{ x: '600px' }}
                />
              </div>
              <div
                style={{
                  position: 'sticky',
                  bottom: 0,
                  zIndex: 1000,
                  background: '#fff',
                  padding: 10,
                  display: 'flex',
                  justifyContent: 'flex-end',
                }}
              >
                <Pagination
                  current={pageBundle}
                  pageSize={pagesizeBundle}
                  total={totalRecordBundles}
                  showSizeChanger
                  onShowSizeChange={handlePageSizeChangeBundle}
                  pageSizeOptions={["20", "50", "100"]}
                  showTotal={total => `Total ${total} items`}
                  onChange={handlePageChangeBundle}
                  locale={{ items_per_page: 'Items / Page' }}
                />
              </div>
            </div>
          </TabPane>
          <TabPane tab="Shift Excess Bundle to Work Order" key="3">
            <ShiftBundleToWorkOrder />
          </TabPane>
        </Tabs>
      </div>{' '}
    </div>
  );
}

export default ExcessStockList;
